<template>
  <Container>
    <template #title>Payment method</template>
    <template #subtitle>This will be used to pay creators for videos.</template>
    <template #form>
      <div class="card-form-wrapper">
        <StripeCard ref="stripeCard" />
      </div>

      <div class="form-buttons grid">
        <Button class="p-button-md p-button-secondary p-justify-center" @click="onPrev">
          <i class="pi pi-arrow-left p-mr-2"></i>
          Back
        </Button>
        <Button label="Finish setup" class="p-button-md" @click="createCard" :loading="loading" />
      </div>

      <div class="skip">
        <Button label="Skip for now" class="p-button-text p-button-secondary width-auto" @click="skip" />
      </div>

      <ErrorModal v-model:visible="errorModalVisible">
        <template #title>Uh oh!</template>
        <template #buttons>
          <Button label="Try again" class="p-button-md" @click="tryAgain" />
        </template>
        {{ errorMessage }}
      </ErrorModal>
    </template>
  </Container>
</template>

<script setup>
import {ref} from "vue";
import Container from "./Container";
import {useRouter} from "vue-router";
import StripeCard from "../../../components/StripeCard";
import {useBrand} from "../../../hooks/useBrand";
import {useStore} from "vuex";
import ErrorModal from "../../../components/ErrorModal";
import {useUser} from "../../../hooks/useUser";
import {usePaymentCard} from "../../../hooks/usePaymentCard";

const emit = defineEmits(['onPrev']);

const store = useStore();
const router = useRouter();
const {addNewCard} = useBrand();
const {finishBrandRegistration} = useUser();
const {create} = usePaymentCard();

const errorModalVisible = ref(false);
const errorMessage = ref();
const loading = ref(false);
const stripeCard = ref();

const createCard = async () => {
  loading.value = true;

  try {
    const setupIntent = await stripeCard.value.submit();

    if (setupIntent) {
      await create({pm_id: setupIntent.payment_method});
      await finishBrandRegistration();
      await store.dispatch('auth/user');

      await router.push({'name': 'dashboard'});
    }
  } catch (e) {
    showErrorModal(e);
  } finally {
    loading.value = false;
  }
}

const onPrev = () => emit('onPrev');
const tryAgain = () => errorModalVisible.value = false

const showErrorModal = (e) => {
  errorMessage.value = e.message;
  errorModalVisible.value = true;
}

const skip = async () => {
  await finishBrandRegistration();
  await store.dispatch('auth/user');
  await store.dispatch('user/skipStripeConnect', true);
  await router.push({'name': 'dashboard'});
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/theme_variables";

.card-form-wrapper {
  margin-top: toRem(22);
}

.form-buttons {
  margin-top: toRem(22);


  &.grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: toRem(8);
  }
}

.skip {
  margin-top: toRem(20);
  text-align: center;

  .p-button {
    color: #8A8EA6 !important;
  }
}
</style>
